import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';
import { MAP } from 'react-google-maps/lib/constants';
import PropTypes from 'prop-types';

const GMap = withScriptjs(withGoogleMap(class extends Component {

    componentDidMount() {
        this.props.onReady && this.props.onReady(this.refs.gmaps.context[MAP])
    }

    render() {
        return <GoogleMap ref="gmaps" {...this.props} />
    }
}));

export default class Map extends Component {
    googleMapsAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    render() {
        console.log(this.googleMapsAPIKey);
        return (
            <GMap
                googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + this.googleMapsAPIKey + "&v=3.exp&libraries=geometry,drawing,places"}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                {...this.props}
            />
        );
    }
}

Map.propTypes = {
    defaultZoom: PropTypes.number.isRequired,
    defaultCenter: PropTypes.object.isRequired
};
